module.exports = __webpack_public_path__ + "img/mac_on.d66d26bb.png";